import * as Sentry from '@sentry/react';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {BrowserRouter} from 'react-router-dom';
import {useAxiosInterceptor, useDelay, useGetCountry, useTheme} from 'hooks';
import {BannerImpersonate, ErrorFallback} from 'components';
import {usePersistentStore} from 'stores';
import {Routers} from 'pages';

import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const App = () => {
  useTheme();
  useAxiosInterceptor();
  useGetCountry();
  const impersoating = usePersistentStore(s => s.impersonating);
  const {isDelaying} = useDelay(0);
  if (isDelaying) {
    return <main className="text-black bg-slate-50 dark:bg-darkBg dark:text-darkText duration-200 select-none"></main>;
  }
  return (
    <main className="text-black bg-slate-50 dark:bg-darkBg dark:text-darkText duration-200 select-none">
      <Sentry.ErrorBoundary fallback={ErrorFallback}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <Routers />
            {impersoating && <BannerImpersonate />}
            <ToastContainer hideProgressBar position="bottom-right" theme="colored" />
          </BrowserRouter>
        </QueryClientProvider>
      </Sentry.ErrorBoundary>
    </main>
  );
};

export default App;
